/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { Order } from './Order';
// @ts-ignore
import {
// @ts-ignore
    OrderFromJSON,
// @ts-ignore
    OrderFromJSONTyped,
// @ts-ignore
    OrderToJSON,
} from './Order';

/**
 * 
 * @export
 * @interface OrderListResponse
 */
export interface OrderListResponse {
    /**
     * 
     * @type {number}
     * @memberof OrderListResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderListResponse
     */
    estimatedTotalCount: number;
    /**
     * 
     * @type {Array<Order>}
     * @memberof OrderListResponse
     */
    items: Array<Order>;
}

/**
 * Check if a given object implements the OrderListResponse interface.
 */
// @ts-ignore
export function instanceOfOrderListResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "estimatedTotalCount" in value;
    isInstance = isInstance && "items" in value;

    return isInstance;
}

// @ts-ignore
export function OrderListResponseFromJSON(json: any): OrderListResponse {
    return OrderListResponseFromJSONTyped(json, false);
}

// @ts-ignore
export function OrderListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderListResponse {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'total_count') ? undefined : json['total_count'],
        'estimatedTotalCount': json['estimated_total_count'],
        'items': ((json['items'] as Array<any>).map(OrderFromJSON)),
    };
}

// @ts-ignore
export function OrderListResponseToJSON(value?: OrderListResponse | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total_count': value.totalCount,
        'estimated_total_count': value.estimatedTotalCount,
        'items': ((value.items as Array<any>).map(OrderToJSON)),
    };
}

